<template>
  <Layout>
    <section class="csms-settlement">

      <!-- Page Title Start -->
      <PageHeader :title="title" />
      <!-- Page Title End -->

      <!-- Search Area Start -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row">

                <!-- // Search Input -->
                <div class="col-xl-10 ion-mb-mb-100">
                  <div class="row">
                    <div class="col-xl-3" v-if="$_app.user.roles[0] === 'ADMIN'">
                      <label class="form-label" for="manager-search-hq">{{ $t('common.headquarters') }}</label>
                      <multiselect id="manager-search-hq"
                                   v-model="searchForm.hqId"
                                   label="text" track-by="value"
                                   :options="hqOptions"
                                   selectLabel=""
                                   selectedLabel=""
                                   deselectLabel=""
                                   :searchable="false" :allow-empty="false" />
                    </div>
                    <div class="col-xl-3">
                      <label class="form-label" for="manager-search-cp">{{ $t('common.cp') }}</label>
                      <multiselect id="manager-search-cp"
                                   label="text" track-by="value"
                                   v-model="searchForm.cpId"
                                   :options="cpOptions"
                                   selectLabel=""
                                   selectedLabel=""
                                   deselectLabel=""
                                   :searchable="false" :allow-empty="false" />
                    </div>
                    <div class="col-xl-2">
                      <label class="form-label">{{ $t('settlement.displayPeriod') }}</label>
                      <div class="btn-group w-100" role="group">
                        <button type="button"
                                class="btn btn-outline-secondary"
                                :class="{ 'active': searchForm.periodType === 'year' }"
                                @click="searchForm.periodType = 'year'">
                          {{ $t('settlement.year') }}
                        </button>
                        <button type="button"
                                class="btn btn-outline-secondary"
                                :class="{ 'active': searchForm.periodType === 'month' }"
                                @click="searchForm.periodType = 'month'">
                          {{ $t('settlement.month') }}
                        </button>
                      </div>
                    </div>
                    <div class="col-xl-3">
                      <label class="form-label">{{ $t('settlement.Settlementperiod') }}</label>
                      <div class="row g-2">
                        <div :class="searchForm.periodType === 'year' ? 'col-6' : 'col-6'">
                          <multiselect v-model="searchForm.selectedYear"
                                       label="text" track-by="value"
                                       :options="yearOptions"
                                       selectLabel=""
                                       selectedLabel=""
                                       deselectLabel=""
                                       :searchable="false"
                                       :allow-empty="false" />
                        </div>
                        <div class="col-6" v-show="searchForm.periodType === 'month'">
                          <multiselect v-model="searchForm.selectedMonth"
                                       label="text" track-by="value"
                                       :options="monthOptions"
                                       selectLabel=""
                                       selectedLabel=""
                                       deselectLabel=""
                                       :searchable="false"
                                       :allow-empty="false" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- // Search Button -->
                <div class="col-xl-2 align-content-end">
                  <div class="float-end">
                    <b-button variant="secondary" class="me-3" @click="reset">
                      <i class="uil uil-redo me-2"></i>
                      <span>{{ $t('btn.reset') }}</span>
                    </b-button>
                    <b-button variant="primary" @click="search">
                      <i class="uil uil-search me-2"></i>
                      <span>{{ $t('btn.search') }}</span>
                    </b-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Search Area End -->

      <!-- Summary Start -->
      <div class="row">
        <div class="col-xl-3">
          <SummaryCardWithSlot :value="infoItems.totalChargeFee" :unit="$t('unit.money').toString()">
            <template v-slot:title>
              <!--              <span class="text-black-50 pe-1">[선택 날짜]</span>-->
              <span class="fw-bold">{{ $t('settlement.totalChargeFee') }}</span>
            </template>
            <template v-slot:icon>
              <i class="mdi mdi-credit-card-multiple font-size-26" />
            </template>
          </SummaryCardWithSlot>
        </div>
        <!--        <div class="col-xl-2">
                  <SummaryCardWithSlot :value="infoItems.zeroPlanPrice" :unit="$t('unit.money').toString()">
                    <template v-slot:title>
                      &lt;!&ndash;              <span class="text-black-50 pe-1">[선택 날짜]</span>&ndash;&gt;
                      <span class="fw-bold">총 제로 플랜 이용료</span>
                    </template>
                    <template v-slot:icon>
                      <i class="mdi mdi-wallet-membership font-size-26" />
                    </template>
                  </SummaryCardWithSlot>
                </div>-->
        <div class="col-xl-3">
          <SummaryCardWithSlot :value="infoItems.vatPrice" :unit="$t('unit.money').toString()">
            <template v-slot:title>
              <!--              <span class="text-black-50 pe-1">[선택 날짜]</span>-->
              <span class="fw-bold">{{ $t('settlement.vatPrice') }}</span>
            </template>
            <template v-slot:icon>
              <i class="mdi mdi-cards-outline font-size-26" />
            </template>
          </SummaryCardWithSlot>
        </div>
        <div class="col-xl-3">
          <SummaryCardWithSlot :value="infoItems.serverUsageFee" :unit="$t('unit.money').toString()">
            <template v-slot:title>
              <!--              <span class="text-black-50 pe-1">[선택 날짜]</span>-->
              <span class="fw-bold">{{ $t('settlement.serverUsageFee') }}</span>
            </template>
            <template v-slot:icon>
              <i class="mdi mdi-server font-size-26" />
            </template>
          </SummaryCardWithSlot>
        </div>
        <div class="col-xl-3">
          <SummaryCardWithSlot :value="infoItems.settlePrice" :unit="$t('unit.money').toString()">
            <template v-slot:title>
              <!--              <span class="text-black-50 pe-1">[선택 날짜]</span>-->
              <span class="fw-bold">{{ $t('settlement.settlePrice') }}</span>
            </template>
            <template v-slot:icon>
              <i class="mdi mdi-calculator font-size-26" />
            </template>
          </SummaryCardWithSlot>
        </div>
      </div>
      <!-- Summary End -->

      <!-- List Start -->
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">

              <div class="row mb-3 align-items-end">
                <!-- // List PerPage Count -->
                <div class="col-auto">
                  <PerPageSelector v-model="pagination.perPage"
                                   :option="[50, 100, 200]"
                                   @change="onPerPageChange" />
                </div>
                <!-- // Total Count -->
                <div class="col me-2">
                  <div class="float-end">
                    <total-count :total-count="pagination.totalCount" />
                  </div>
                </div>
              </div>

              <!-- // List -->
              <div class="table-responsive">
                <b-table class="text-nowrap align-middle" bordered hover
                         show-empty :empty-text="$t('settlement.noData')"
                         :fields="fields" :items="items">

                  <template #head()="data">
                    <span v-if="!$_utils.isEmpty(data.label)">{{ $t(`settlement.${data.column}`) }}</span>
                  </template>

                  <template #cell(totalChargeFee)="data">
                    {{ !$_utils.isEmpty(data.item.totalChargeFee) ? $_utils.comma(data.item.totalChargeFee) : '-' }}
                  </template>

                  <template #cell(vatPrice)="data">
                    {{ !$_utils.isEmpty(data.item.vatPrice) ? $_utils.comma(data.item.vatPrice) : '-' }}
                  </template>

                  <template #cell(serverUsageFee)="data">
                    {{ !$_utils.isEmpty(data.item.serverUsageFee) ? $_utils.comma(data.item.serverUsageFee) : '-' }}
                  </template>

                  <template #cell(settlePrice)="data">
                    {{ !$_utils.isEmpty(data.item.settlePrice) ? $_utils.comma(data.item.settlePrice) : '-' }}
                  </template>

                  <template #cell(view)="data">
                    <button class="btn btn-sm btn-outline-primary"
                            @click="viewDetail(data.item)">
                      <i class="uil uil-eye me-2"></i>
                      <span>{{ $t(`settlement.view`) }}</span>
                    </button>
                  </template>

                </b-table>
              </div>

              <!-- // Pagination -->
              <div class="row mt-3">
                <div class="col-xl-12">
                  <b-pagination size="sm" class="mb-0" align="center"
                                :total-rows="pagination.totalCount"
                                :per-page="pagination.perPage"
                                v-model="pagination.currentPage"
                                @change="onPageChange" />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- List End -->

      <detail-modal ref="settlementDetailModal"
                    :place-id="selectedPlaceId"
                    :auth-date="selectedAuthDate"
                    @callback="getItems" />
    </section>
  </Layout>
</template>

<script>
import { http } from '@/auth-api';
import { loadingMethods } from '@/state/helpers';
import i18n from '@/i18n';
import Multiselect from 'vue-multiselect';
import Layout from '@/views/layouts/Main.vue';
import PageHeader from '@/components/PageHeader.vue';
import SummaryCardWithSlot from '@/views/components/SummaryCardwithSlot.vue';
import PerPageSelector from '@/views/components/PerPageSelector.vue';
import TotalCount from '@/views/components/TotalCount.vue';
import DetailModal from '@/views/pages/settlement/settlementDetailModal.vue';


export default {
  components: {
    Multiselect, Layout, PageHeader, SummaryCardWithSlot, PerPageSelector, TotalCount, DetailModal
  },
  data() {
    return {
      title: 'manageSettlement',
      hqOptions: [],
      cpOptions: [],
      searchConditions: [],
      sortDirection: 'DESC',
      pagination: {
        currentPage: 1,
        totalCount : 0,
        perPage: 50
      },
      searchForm: {
        hqId: { text: i18n.t('common.total'), value: null },
        cpId: { text: i18n.t('common.total'), value: null },
        periodType: 'month', // 'year' or 'month'
        selectedYear: { text: i18n.t('common.total'), value: null },
        selectedMonth: { text: i18n.t('common.total'), value: null }
      },
      yearOptions: [],
      monthOptions: [],
      infoItems: {
        totalChargeFee: 0,
        zeroPlanPrice: 0,
        vatPrice: 0,
        serverUsageFee: 0,
        settlePrice: 0
      },
      fields: [
        { key: 'rnum', label: 'No.', class: 'text-center column-w-8' },
        { key: 'hqName', label: '충전기운영자', class: 'text-center' },
        { key: 'placeName', label: '충전 스탠드', class: 'text-center' },
        { key: 'planName', label: '플랜명', class: 'text-center' },
        { key: 'authYearMonth', label: '날짜', class: 'text-center' },
        { key: 'totalChargeFee', label: '매출액', class: 'text-center' },
        { key: 'vatPrice', label: '결제 수수료', class: 'text-center' },
        { key: 'serverUsageFee', label: '시스템 이용료', class: 'text-center' },
        { key: 'settlePrice', label: '정산 금액', class: 'text-center' },
        { key: 'view', label: '상세 내역', class: 'text-center' },
      ],
      items: null,
      selectedPlaceId: null,
      selectedAuthDate: null,
    }
  },
  mounted() {
    const vm = this;

    vm.initYearOptions();
    vm.initMonthOptions();
    vm.getHqOptions();
    vm.getCpOptions();
    vm.getItems();
  },
  watch: {
    'searchForm.periodType'(newValue) {
      // 표시기간을 '월'로 변경하면 전체로 설정
      if (newValue === 'month') {
        this.searchForm.selectedMonth = { text: i18n.t('common.total'), value: null };
      }
    },
    'searchForm.selectedYear'(newValue) {
      // 표시기간이 '월'이고, 년도가 전체가 아니면 월을 1월로 설정
      if (this.searchForm.periodType === 'month' && newValue.value !== null) {
        this.searchForm.selectedMonth = { text: `1${i18n.t('settlement.month')}`, value: 1 };
      }
    }
  },
  methods: {
    ...loadingMethods,
    initYearOptions() {
      const vm = this;
      const currentYear = new Date().getFullYear();

      // 전체 옵션 추가
      vm.yearOptions.push({ text: i18n.t('common.total'), value: null });

      // 현재 년도부터 과거 1년까지 옵션
      for (let i = 0; i <= 1; i++) {
        const year = currentYear - i;
        vm.yearOptions.push({ text: `${year}${i18n.t('settlement.year')}`, value: year });
      }
    },
    initMonthOptions() {
      const vm = this;

      // 전체 옵션 추가
      vm.monthOptions = [{ text: i18n.t('common.total'), value: null }];

      // 월 옵션 (1월 ~ 12월)
      for (let i = 1; i <= 12; i++) {
        vm.monthOptions.push({ text: `${i}${i18n.t('settlement.month')}`, value: i });
      }
    },
    getHqOptions() {
      const vm = this;
      const _url = '/onmapi/view/Hq/listAll';

      http.get(_url, {}).then(res => {
        vm.hqOptions = [{ text: i18n.t('common.total'), value: null }];

        res.data.items.forEach(item => {
          vm.hqOptions.push({text: item.hqName, value: item.id});
        });
      }).catch(err => {
        console.error('Headquarters List Data Error :: ', err)
      });
    },
    getCpOptions() {
      const vm = this;
      const _url = '/onmapi/view/ChargePlace/listAll';

      http.get(_url).then(res => {
        vm.cpOptions = [{ text: i18n.t('common.total'), value: null }];

        res.data.items.forEach(item => {
          vm.cpOptions.push({text: item.placeName, value: item.placeId});
        });
      }).catch(err => {
        console.error('Charge Place List Error :: ', err)
      });
    },
    async reset() {
      const vm = this;

      vm.searchForm = {
        hqId: { text: i18n.t('common.total'), value: null },
        cpId: { text: i18n.t('common.total'), value: null },
        periodType: 'month',
        selectedYear: { text: i18n.t('common.total'), value: null },
        selectedMonth: { text: i18n.t('common.total'), value: null }
      };
      vm.searchConditions = [];

      await vm.getItems();
    },
    async search() {
      const vm = this;

      vm.searchConditions = [];

      if (!this.$_utils.isEmpty(vm.searchForm.hqId.value)) {
        vm.searchConditions.push({ searchKey: 'hqId', searchValue: vm.searchForm.hqId.value });
      }

      if (!this.$_utils.isEmpty(vm.searchForm.cpId.value)) {
        vm.searchConditions.push({ searchKey: 'placeId', searchValue: vm.searchForm.cpId.value });
      }

      // 표시기간에 따라 다른 searchKey 사용
      if (vm.searchForm.periodType === 'year') {
        // 연도만 선택한 경우
        if (!this.$_utils.isEmpty(vm.searchForm.selectedYear.value)) {
          vm.searchConditions.push({
            searchKey: 'authYear',
            searchValue: vm.searchForm.selectedYear.value.toString()
          });
        }
      } else {
        // 월 모드인 경우
        if (!this.$_utils.isEmpty(vm.searchForm.selectedYear.value)) {
          if (!this.$_utils.isEmpty(vm.searchForm.selectedMonth.value)) {
            // 월이 선택되면 authDate로 보냄
            const formattedMonth = vm.searchForm.selectedMonth.value.toString().padStart(2, '0');
            vm.searchConditions.push({
              searchKey: 'authDate',
              searchValue: `${vm.searchForm.selectedYear.value}-${formattedMonth}`
            });
          } else {
            // 월이 전체이면 authYear로 보냄
            vm.searchConditions.push({
              searchKey: 'authYear',
              searchValue: vm.searchForm.selectedYear.value.toString()
            });
          }
        }
      }

      vm.pagination.currentPage = 1;
      await vm.getItems();
    },
    async getItems() {
      const vm = this;
      const _url = '/onmapi/view/Settlement/list';

      vm.showOverlay();

      await http.post(_url, {
        page: vm.pagination.currentPage,
        limit: vm.pagination.perPage,
        searchConditions: vm.searchConditions,
        sortCondition: { sortDirection: vm.sortDirection }
      }).then(res => {
        vm.items = res.data.items;
        vm.pagination.totalCount = res.data.totalCount;

        let _totalChargeFee = 0;
        let _zeroPlanPrice = 0;
        let _vatPrice = 0;
        let _serverUsageFee = 0;
        let _settlePrice = 0;

        vm.items.forEach(function(item) {
          _totalChargeFee += item.totalChargeFee || 0;
          _vatPrice += item.vatPrice || 0;
          _serverUsageFee += item.serverUsageFee || 0;
          _settlePrice += item.settlePrice || 0;

          // plan_id가 10000000000225인 경우만 zeroPlanPrice에 합산
          if (item.planId === 10000000000225) {
            _zeroPlanPrice += item.totalChargeFee || 0;
          }
        });

        vm.infoItems.totalChargeFee = Math.round(_totalChargeFee * 100) / 100;
        vm.infoItems.zeroPlanPrice = Math.round(_zeroPlanPrice * 100) / 100;
        vm.infoItems.vatPrice = Math.round(_vatPrice * 100) / 100;
        vm.infoItems.serverUsageFee = Math.round(_serverUsageFee * 100) / 100;
        vm.infoItems.settlePrice = Math.round(_settlePrice * 100) / 100;
      }).catch(err => {
        console.error('Settlement List Error :: ', err)
      }).finally(() => {
        vm.hideOverlay();
      });
    },
    async onPerPageChange() {
      const vm = this;

      if (vm.pagination.totalCount > 1) {
        vm.pagination.currentPage = 1;
        await vm.getItems();
      }
    },
    async onPageChange(val) {
      const vm = this;
      vm.pagination.currentPage = val;

      if (vm.pagination.totalCount > 1) {
        await vm.getItems();
      }
    },
    viewDetail(item) {
      const vm = this;
      vm.selectedPlaceId = item.placeId;
      vm.selectedAuthDate = item.authYearMonth;

      vm.$nextTick(() => {
        this.$refs.settlementDetailModal.show();
      });
    }
  }
}
</script>

<style src='vue-multiselect/dist/vue-multiselect.min.css'></style>